<template>
  <div class="offering">
    <h2 class="is-size-4-touch">HR Process Management</h2>
    <p>
      HR Process Management is the outsourcing of the client’s Human Resources
      operations, supporting the HR strategy. This includes placing of ace HR
      professionals at the clients premise with strategic HR Management
      advisory. This helps the Client to acquire the services of seasoned HR
      professionals at an affordable cost. It helps the client to address
      long-term issues with short-term cost.
    </p>
    <p>We do this through:</p>
    <ul>
      <li>
        Analysis of the existing HR processes and systems from an external
        perspective.
      </li>
      <li>
        Alignment of systems and processes to achieve the strategic business
        goals and objectives.
      </li>
      <li>
        Effective people management to create a performance driven culture.
      </li>
      <li>Climate mapping and proactive employee engagement.</li>
      <li>Identification of gaps in the work culture.</li>
      <li>
        Identification of critical roles and valuable assistance in succession
        planning.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OfferingHPM",
  props: {},
};
</script>
